import { format } from 'date-fns'
import { SpItem, SpColumn } from './StyledElements'
import { useSessionWS } from '../utils/hooks'

const SpeedItem = ({ id, oneSpeed, onClick, isGrey, isSelected, wA }) => {
  const { sessionWS } = useSessionWS()
  let temp_bg
  let temp_cl = 'black'
  if (!isSelected && !isGrey) {
    temp_bg = 'white'
  } else if (isSelected) {
    temp_bg = '#0275d8'
    temp_cl = 'white'
    // } else temp_bg = 'rgba(0,0,0,.05)'
  } else temp_bg = 'rgba(0,0,0,.00)'
  let i = 0

  return (
    <>
      <SpItem
        onClick={() => {
          onClick(id)
        }}
        bg={temp_bg}
        cl={temp_cl}
      >
        <SpColumn id={id} w={wA[i]} align={'left'}>
          {format(new Date(oneSpeed.timeU), 'HH:mm:ss', {
            timeZone: sessionWS.timeZone,
          })}
        </SpColumn>
        <SpColumn id={id} w={wA[++i]} align={'right'}>
          {(Math.round(oneSpeed.speed * 10) / 10).toLocaleString(undefined, {
            minimumFractionDigits: 1,
          })}
        </SpColumn>
      </SpItem>
    </>
  )
}

export default SpeedItem
